<template>
    <div>
        <label
            v-if="floatLabel"
            class="caption pl-2.5 soli-grey justify-start flex"
            for="password"
            >Create a password</label
        >
        <SoliText
            @input="$emit('input', $event)"
            :value="value"
            :label="floatLabel ? null : 'Create a password'"
            outlined
            :rules="rules"
            name="password"
            ref="password"
            :hide-details="hideDetails"
            :icon="icon ? 'password' : null"
            :errors="errors"
            password
            :show="show"
            @append="show = !show"
            @keydown.enter="$emit('keydown', $event)"
        ></SoliText>
    </div>
</template>

<script>
export default {
    props: {
        value: {},
        errors: {},
        hideDetails: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: Boolean,
            default: false,
        },
        floatLabel: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            rules: [(v) => !!v || "Password is required"],
            show: false,
        };
    },
};
</script>

<style></style>
